import CancelablePromise from 'mn-utils/CancelablePromise';
import {getAssetsAmountList} from './mock';
import {TAssetsAmount} from './types';
import {apiRequest} from '../../ws';
import {
  ENDPOINT_ASSETS_AMOUNT_LIST,
  ENDPOINT_ASSETS_AMOUNT_LIMITS,
  ENDPOINT_KLUB_FEE_AMOUNT,
  ENDPOINT_NCDT_FEE_AMOUNT
} from '../../../constants/api';
import {TList} from '@/types';

export function apiV2AssetsAmountList(params): Promise<TList<TAssetsAmount>> {
  const url = ENDPOINT_ASSETS_AMOUNT_LIST;
  if (process.env.MOCK) {
    const response = {
      list: getAssetsAmountList(5),
      count: 5,
    };
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequest(url, params);
}

export function apiV2AssetsAmountLimits(params): Promise<TList<TAssetsAmount>> {
  const url = ENDPOINT_ASSETS_AMOUNT_LIMITS;
  if (process.env.MOCK) {
    const response = {
      list: getAssetsAmountList(5),
      count: 5,
    };
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequest(url, params);
}

export function apiV2KlubcoinAmountFees(params): Promise<TList<TAssetsAmount>> {
  const url = ENDPOINT_KLUB_FEE_AMOUNT;
  if (process.env.MOCK) {
    const response = {
      list: getAssetsAmountList(5),
      count: 5,
    };
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequest(url, params);
}

export function apiV2NCDTAmountFees(params): Promise<TList<TAssetsAmount>> {
  const url = ENDPOINT_NCDT_FEE_AMOUNT;
  if (process.env.MOCK) {
    const response = {
      list: getAssetsAmountList(5),
      count: 5,
    };
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequest(url, params);
}
